import {  GameAnnouncements, PopupDisplay,  } from "../../types/global";

export const actionTypes = {
    SET_ANNOUNCEMENTS: 'SET_ANNOUNCEMENTS',
    SET_POPUP_DISPLAY: 'SET_POPUP_DISPLAY',
    CLEAR_ANNOUNCEMENTS: 'CLEAR_ANNOUNCEMENTS',
};

// Action creators
export const setAnnouncements = (payload:GameAnnouncements) => ({
    type: actionTypes.SET_ANNOUNCEMENTS,
    payload,
});

export const clearAnnouncements = () => ({
    type: actionTypes.CLEAR_ANNOUNCEMENTS,
});

// Action creators
export const setPopupDisplay = (payload:PopupDisplay) => ({
    type: actionTypes.SET_POPUP_DISPLAY,
    payload,
});